import React, { useState } from 'react'
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { accountData } from '../../redux/actions/dashboardAction';
import { useDispatch } from 'react-redux';
import Select from './Select';


const DashboardAccount = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [industry, setIndustry] = useState({ id: "this_month", name: "this month" },)
  const [account, setAccount] = useState({ id: "this_month", name: "this month" },)
  const [starredAccount, setStarredAccount] = useState({ id: "this_month", name: "this month" },)
  const dashboardData = useSelector(
    (state) => state.dashboard.fetchDashboardData
  );
  const accountDashData = useSelector(
    (state) => state.dashboard.accountDash
  );

  const dayTypes = [
    { id: "today", name: "today" },
    { id: "this_week", name: "this week" },
    { id: "this_month", name: "this month" },
  ];


  useEffect(()=>{
    dispatch(
      accountData(
        props.authToken,
        account?.id,industry?.id,starredAccount?.id
      )
    );
  },[account,industry,starredAccount])

  return (
    <>

<div className='bg-gray-100'>
      <div className='h-[100vh] pt-[4rem] overflow-y-auto listing'>
    <div className="px-16 max-sm:px-6 flex justify-between shadow-md mb-4 bg-white">
      <div className="flex flex-col my-2">
        <div className="text-lg leading-7 font-normal text-gray-700">
          Hello,
        </div>
        <div className="text-2xl leading-8 font-medium capitalize text-gray-900">
          {dashboardData?.details?.profile_name}
        </div>
      </div>
      <div className='flex mt-3'>
        <div className='flex flex-col px-4 cursor-pointer' onClick={()=>{navigate("/Analytics")}}>
          <div className='text-lg leading-7 font-semibold text-gray-700'>Leads</div>
          <div className='text-sm leading-5 font-normal text-gray-400'>47 new leads</div>
        </div>
        <div className='flex flex-col px-4 cursor-pointer border-solid border-b-2 border-emerald-500' onClick={()=>{navigate("/Analytics/Accounts")}}>
          <div className='text-lg leading-7 font-semibold text-emerald-500'>Accounts</div>
          <div className='text-sm leading-5 font-normal text-gray-400'>20% Active accounts</div>
        </div>
        {/* <div className='flex flex-col px-4 cursor-pointer'>
          <div className='text-lg leading-7 font-semibold text-gray-700'>Funnel</div>
          <div className='text-sm leading-5 font-normal text-gray-400'>50% bounce rate</div>
        </div> */}
      </div>
    </div>
    <div className="px-4 sm:px-16 flex flex-col">
      {/* Top Section */}
      <div className="grid grid-cols-9 gap-11">
        <div className="max-sm:col-span-9 max-lg:col-span-5 col-span-2 grid grid-rows-1">
          <div className="rounded-[40px] p-8 bg-emerald-900 flex flex-col">
            <div className="my-auto">
              <div className="text-white text-3xl leading-6 font-bold mb-3">
                {accountDashData?.details?.total_data?.total_signals}
              </div>
              <div className="text-gray-300 text-sm leading-5 font-medium">
              New accounts were added since adding Zoi to your website
              </div>
            </div>
          </div>
        </div>
        <div className="max-lg:col-span-9 col-span-7 grid grid-rows-1">
          <div className="rounded-lg p-6 shadow-md bg-white">
            <div className="grid grid-cols-9">
              {/* left box */}
              <div className="col-span-9 sm:col-span-2 grid grid-rows-2 gap-y-6">
                <div className="grid grid-cols-1">
                  <div className="px-6">
                    <div className="flex justify-between border-b border-3 border-gray-200 pb-2">
                      <div className="text-sm leading-5 font-medium text-gray-500">
                      Accounts
                      </div>
                      {/* <div className='text-sm leading-5 font-bold text-red-600'>-5.4%</div> */}
                    </div>
                    <div className="pt-3 text-2xl leading-8 font-semibold">
                      {accountDashData?.details?.total_data?.total_accounts}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1">
                  <div className="px-6">
                    <div className="flex justify-between border-b border-3 border-gray-200 pb-2">
                      <div className="text-sm leading-5 font-medium text-gray-500">
                        Industry Sectors
                      </div>
                      {/* <div className='text-sm leading-5 font-bold text-green-600'>+5.4%</div> */}
                    </div>
                    <div className="pt-3 text-2xl leading-8 font-semibold">
                      {accountDashData?.details?.total_data?.total_industry_sector}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1">
                  <div className="px-6">
                    <div className="flex justify-between border-b border-3 border-gray-200 pb-2">
                      <div className="text-sm leading-5 font-medium text-gray-500">
                        Most Common Region
                      </div>
                      {/* <div className='text-sm leading-5 font-bold text-green-600'>+5.4%</div> */}
                    </div>
                    <div className="pt-3 text-2xl leading-8 font-semibold">
                      {accountDashData?.details?.total_data?.most_common_region}
                    </div>
                  </div>
                </div>
              </div>
              {/* Right box */}
              <div className="col-span-9 sm:col-span-7 grid grid-rows-1">
                {/* <BarGraph mobileView={mobileView} barData={barData} clickData={clickData}/> */}
                {/* <div>Abhishek</div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom section */}
      <div className="grid grid-cols-9 gap-4 my-6">
        
        <div className="max-lg:col-span-8 col-span-3 grid grid-rows-1">
          <div className="rounded-lg p-1 shadow-md bg-white px-6">
            <div className='flex justify-between my-auto border-b border-gray-200'>  
            <div className="py-5 text-base leading-6 font-semibold text-gray-500 ">
              Starred Accounts
            </div>
            {/* <div className='text-green-600 font-bold my-auto'>{`13%(New)`}</div> */}
            </div>
            <div className='text-4xl flex justify-between font-semibold mt-4'>
              <div className='my-auto'>{accountDashData?.details?.starred_accounts?.count}</div>
              <div><div className="rounded-md my-auto px-3 shadow-sm ring-1 ring-inset ring-gray-300">
                    <Select
                      people={dayTypes}
                      selected={starredAccount}
                      setSelected={setStarredAccount}
                    />
                  </div></div>
              </div>
            {/* <div className='text-base mt-12 text-gray-400'>Cursus orci non urna donec mauris mattis id aliquam adipiscing. Ac metus augue metus natoque maecenas.</div> */}
            <div className='flex border-b border-gray-200 py-4'>
            <div className='text-base mt-6 text-black font-semibold '>Recently Signals</div>
            </div>
            <div className='h-[40vh] overflow-y-auto removeScroll'>
             {accountDashData?.details?.starred_accounts?.data.map((item) => {
            return (
            <div className='flex justify-between py-4 border-b border-gray-200'>
             <div className='text-gray-900'>{item?.name}</div>
              <div className='text-gray-900 my-auto font-[600]'>{item?.signal_date}</div>
            </div>
            )})}
            </div>
            {/* {dashboardData?.details?.word_cloud?.length > 0 ? <div className="pt-2">
              <ReactWordcloud words={dashboardData?.details?.word_cloud} options={options} />
            </div>: <div className="flex justify-center items-center">
                <div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[20%] font-[bolder] text-center font-add">
                <span className="flex justify-center items-center text-[40px]">
                  <Icon.Inbox />
                </span>
                No Data
              </div>
                </div>} */}
          </div>
        </div>
        <div className="max-lg:col-span-8 col-span-3 grid grid-rows-1">
          <div className="rounded-lg p-1 shadow-md bg-white px-6">
          <div className='flex justify-between my-auto  border-b border-gray-200'>  
            <div className="py-5 text-base leading-6 font-semibold text-gray-500 ">
             Account Signals
            </div>
            {/* <div className='text-green-600 font-bold my-auto'>{`13%(New)`}</div> */}
            </div>
            <div className='text-4xl font-semibold mt-4 flex justify-between'>
            <div className='my-auto'>{accountDashData?.details?.account_signals?.count}</div>
              <div><div className="rounded-md my-auto px-3 shadow-sm ring-1 ring-inset ring-gray-300">
                    <Select
                      people={dayTypes}
                      selected={account}
                      setSelected={setAccount}
                    />
                  </div></div>
            </div>
            {/* <div className='text-base mt-12 text-gray-400'>Cursus orci non urna donec mauris mattis id aliquam adipiscing. Ac metus augue metus natoque maecenas.</div> */}
            <div className='flex border-b border-gray-200 py-4'>
            <div className='text-base mt-6 text-black font-semibold '>Recently Signals</div>
            </div>
            <div className='h-[40vh] overflow-y-auto removeScroll'>
             {accountDashData?.details?.account_signals?.data.map((item) => {
            return (
            <div className='flex justify-between py-4 border-b border-gray-200'>
              <div className='text-gray-900'>{item?.name}</div>
              <div className='text-gray-900 my-auto font-[600]'>{item?.signal_date}</div>
            </div>
            )})}
            </div>
          </div>
        </div>
        <div className="max-lg:col-span-8 col-span-3 grid grid-rows-1">
          <div className="rounded-lg p-1 shadow-md bg-white px-6">
          <div className='flex justify-between my-auto border-b border-gray-200'>  
            <div className="py-5 text-base leading-6 font-semibold text-gray-500 ">
              Industry Signals
            </div>
            {/* <div className='text-green-600 font-bold my-auto'>{`13%(New)`}</div> */}
            </div>
            <div className='text-4xl font-semibold mt-4 flex justify-between'>
            <div className='my-auto'>{accountDashData?.details?.industry_signals?.count}</div>
              <div><div className="rounded-md my-auto px-3 shadow-sm ring-1 ring-inset ring-gray-300">
                    <Select
                      people={dayTypes}
                      selected={industry}
                      setSelected={setIndustry}
                    />
                  </div></div>
            </div>
            {/* <div className='text-base mt-12 text-gray-400'>Cursus orci non urna donec mauris mattis id aliquam adipiscing. Ac metus augue metus natoque maecenas.</div> */}
            <div className='flex border-b border-gray-200 py-4'>
            <div className='text-base mt-6 text-black font-semibold '>Industries by Signals</div>
            </div>
            <div className='h-[40vh] overflow-y-auto removeScroll'>
             {accountDashData?.details?.industry_signals?.data.map((item) => {
            return (
            <div className='flex justify-between py-4 border-b border-gray-200'>
              <div className='text-gray-900'>{item?.name}</div>
              <div className='text-gray-900 my-auto font-[600]'>{item?.signal_count}</div>
            </div>
            )})}
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
  </>
  )
}

export default DashboardAccount